import { tienFormat } from "./NumberUtils";

export function BuildSMSTraLaiMB(data: any[]): string {
    let result = ""
    let hashMap = new Map<string, string>()
    data.map((item, index) => {
        const { dai, loai, so, diemDaNhan, diemThem, hanMuc } = item
        let diem = (diemThem+"").padStart(10,"0");
        const key = `${loai}:${diem}`
        const valueToAdd = so;
        let curMapItem = hashMap.get(key)
        let separator = ","
        switch (loai) {
            case "Xi2": case "Xi3": case "Xi4":
                separator = "/"
        }
        if (curMapItem) {
            hashMap.set(key, `${curMapItem}${separator}${valueToAdd}`)
        } else {
            hashMap.set(key, valueToAdd)
        }
    })
    // bắt đầu build sms từ hashMap
    let preLoai = ""
    let addLoai = ""
    // sắp xếp theo số điểm giảm dần
    const sortedKeys = Array.from(hashMap.keys()).sort((a, b) => {
        if (a > b) return -1; // Nếu a lớn hơn b, đặt a trước b
        if (a < b) return 1; // Nếu a nhỏ hơn b, đặt b trước a
        return 0; // Nếu a bằng b, không đổi vị trí của a và b
    });
    //
    sortedKeys.forEach((key) => {
        const value = hashMap.get(key)
        const [loai, d] = key.split(":")
        const diem = parseInt(d)
        let dvt = "n"
        if (loai == "Lo")
            dvt = "d"
        // vòng lặp trước
        addLoai = loai;
        if (addLoai != "")
            addLoai = `${addLoai}: `
        if (preLoai == loai)
            addLoai = "";
        let tmp = `${addLoai}${value}x${diem}${dvt}.`
        if (!isNaN(diem))
            result += `${tmp}`
        // vòng lặp sau
        preLoai = loai
    })
    if (result.length > 0)
        result = `Tra lai: ${result}`
    return result
}